import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import Modal from 'common-ui/modal';
import { bulkUnassignLeads } from 'features/newsales/newsalesActions';

import {
  ButtonRow,
  CancelButton,
  ConfirmButton,
  ConfirmText,
  ErrorMessage,
  LeadCountBadge,
  ModalContent,
} from './UnassignLeadModal.styles';

const UnassignLeadModal = ({ isOpen, leadIds = [], onSuccess, onClose }) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setIsSubmitting(true);
    setError('');
    try {
      await dispatch(bulkUnassignLeads({ leadIds })).unwrap();
      if (onSuccess) onSuccess();
      handleClose();
    } catch (err) {
      setError(err?.message || err || 'Failed to unassign lead');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Unassign"
      footer={false}
      width="400px"
      closeIcon={true}
    >
      <ModalContent>
        <ConfirmText>
          Are you sure you want to unassign{' '}
          <LeadCountBadge>
            {leadIds.length} lead{leadIds.length !== 1 ? 's' : ''}
          </LeadCountBadge>
          ?
        </ConfirmText>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <ButtonRow>
          <CancelButton onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </CancelButton>
          <ConfirmButton onClick={handleConfirm} disabled={isSubmitting}>
            {isSubmitting ? 'Unassigning...' : 'Confirm'}
          </ConfirmButton>
        </ButtonRow>
      </ModalContent>
    </Modal>
  );
};

export default UnassignLeadModal;
